// src/components/Tooltip/context.ts
import { createContext } from "react";
var TooltipContext = createContext({
  id: ""
});
export { TooltipContext };